/**
 * 各マスタ画面の行から、その対象の変更履歴 (②) へ移るリンク (マスタ変更履歴 SBI 7)。
 *
 * 履歴は別ウィンドウで開く (遷移元の画面の表示状態を保つため。Issue #890)。
 * 開けないときは同じタブで遷移する。
 *
 * 履歴を見る権限 (元のマスタ画面と同じ機能) が無ければ何も描画しない。
 * ルーターや権限コンテキストの外で描画された場合も、描画せずに終わる
 * (権限に関係ない画面のテストに Provider / Router を要求しないため)。
 *
 * ⚠️ 出し分けは利便性のため。最終的な拒否は常にバックエンドの 403。
 */
import { Link, useInRouterContext } from 'react-router';

import { useOptionalPermissions } from '../contexts/PermissionContext';
import { MASTER_HISTORY_FEATURE_BY_TYPE } from '../permissions/masterHistoryFeatures';
import { buildTargetPath, type MasterHistoryTarget } from '../pages/masterHistoryTarget';
import { openMasterHistoryInNewWindow } from '../utils/masterHistoryWindow';

export interface MasterHistoryLinkProps {
  target: MasterHistoryTarget;
  /** 読み上げ用に対象を示す名前 (`<subject> の履歴を見る`)。行の他のボタンと揃える */
  subject: string;
  testId?: string;
}

export function MasterHistoryLink(props: MasterHistoryLinkProps): React.JSX.Element | null {
  const { target, subject, testId } = props;
  const permissions = useOptionalPermissions();
  const inRouter = useInRouterContext();

  if (!inRouter || !permissions?.has(MASTER_HISTORY_FEATURE_BY_TYPE[target.masterType])) {
    return null;
  }
  const path = buildTargetPath(target);
  return (
    <Link
      to={path}
      className="master-history-link"
      aria-label={`${subject} の履歴を見る`}
      data-testid={testId}
      // 行クリックで地図を動かす放送地点の表で、リンクを押した操作が行クリックにもならないようにする。
      onClick={(e) => {
        e.stopPropagation();
        openMasterHistoryInNewWindow(e, path);
      }}
    >
      履歴を見る
    </Link>
  );
}
